import { useState, useEffect } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase";
import "../styles/enquiry_dialog.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const EnquiryDialog = ({ isOpen, onClose, name, eventId, dateList }) => {
  const [selectedValue, setSelectedDropDown] = useState("");
  const [formData, setFormData] = useState({
    eventId: "",
    ev_name: "",
    fullName: "",
    adults: "",
    children: "",
    startDate: "",
    endDate: "",
    phone: "",
    message: "",
    createdDate: "",
  });
  const [date, setDate] = useState([null, null]);
  const [datesArray, setDatesArray] = useState([]);
  const [loading, setLoading] = useState(false);

  const [startDate, endDate] = date;

  useEffect(() => {
    const getFutureTimestamps = (dateList) => {
      const now = Date.now();
      setDatesArray(dateList.filter((timestamp) => timestamp.start_date > now));
    };
    getFutureTimestamps(dateList);
  }, [dateList]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const submit = async (e) => {
    formData.startDate = startDate ? startDate.valueOf() : null;
    formData.endDate = endDate ? endDate.valueOf() : null;
    e.preventDefault();
    setLoading(true);
    const data = {
      event_id_cr_date: eventId,
      ev_name: name,
      name: formData.fullName,
      number_count: formData.adults,
      child_count: formData.children.isEmpty ? "0" : formData.children,
      contact: formData.phone,
      message: formData.message,
      batch: selectedValue,
      selected_date: {
        start_date: formData.startDate,
        end_date: formData.endDate,
      },
      created_date: new Date().valueOf(),
    };

    try {
      await addDoc(collection(db, "enquiries"), data);
      onClose();
      // alert("Enquiry submitted!");
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoading(false);
      alert("Enquiry submitted!");
    }
  };

  if (!isOpen) return null;

  const formatDate = (ms) => {
    const date = new Date(ms);
    return date.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <div className="dialog-overlay">
      <div className="dialog-box">
        <h2>Enquiry Form</h2>
        <p>{name}</p>
        <div className="dialog-box-div">
          <input
            style={{ display: "flex", width: "100%" }}
            type="text"
            name="fullName"
            placeholder="Full Name"
            value={formData.fullName}
            onChange={handleChange}
          />
        </div>
        <div className="dialog-box-div">
          <input
            type="number"
            name="adults"
            placeholder="Adults Count"
            value={formData.adults}
            onChange={handleChange}
          />
          <input
            type="number"
            name="children"
            placeholder="Children Count"
            value={formData.children}
            onChange={handleChange}
          />
        </div>
        <div style={{ display: "flex" }}>
          {datesArray && datesArray.length !== 0 ? (
            <div className="dropdown-container">
              <select
                className="dropdown-select"
                value={selectedValue}
                onChange={(e) => {
                  return setSelectedDropDown(e.target.value);
                }}
              >
                <option value="">Select Date</option>
                {datesArray.map((opt, index) => {
                  const label = `${formatDate(opt.start_date)} - ${formatDate(
                    opt.end_date
                  )}`;
                  return (
                    <option key={index} value={label}>
                      {label}
                    </option>
                  );
                })}
              </select>
            </div>
          ) : (
            <></>
          )}
          <DatePicker
            placeholderText="Customise Date"
            selected={startDate}
            startDate={startDate}
            endDate={endDate}
            onChange={(date) => setDate(date)}
            selectsRange
          />
        </div>
        <div className="dialog-box-div">
          <input
            type="number"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
          />
        </div>

        <div className="dialog-box-div">
          <textarea
            type="text"
            name="message"
            placeholder="Enquiry Message"
            value={formData.message}
            onChange={handleChange}
          ></textarea>
        </div>

        <div style={{ display: "flex", gap: "20px" }}>
          <button className="close-button" onClick={onClose}>
            Close
          </button>
          {loading ? (
            <button className="submit-button">Loading...</button>
          ) : (
            <button className="submit-button" onClick={submit}>
              Submit
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default EnquiryDialog;
